<template>
  <ul class="menu-nav">
    <router-link to="/dashboard" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ]">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-pie-chart-4"></i>
          <span class="menu-text">ภาพรวมระบบ</span>
        </a>
      </li>
    </router-link>

    <li class="menu-section">
      <h4 class="menu-text">แผนงานทั้งหมด</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link to="/PlansTable" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ]">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-copy"></i>
          <span class="menu-text">ภาพรวมแผนงาน</span>
        </a>
      </li>
    </router-link>

    <router-link to="/PlansAll" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ]">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-writing"></i>
          <span class="menu-text">สร้างแผนงาน</span>
        </a>
      </li>
    </router-link>

    <li class="menu-section">
      <h4 class="menu-text">จัดการข้อมูลระบบ</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link to="/Config/Company" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ]">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-architecture-and-city"></i>
          <span class="menu-text">ข้อมูลบริษัท</span>
        </a>
      </li>
    </router-link>

    <router-link to="/Config/Contact" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ]">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-calendar-3"></i>
          <span class="menu-text">ข้อมูลผู้ติดต่อ</span>
        </a>
      </li>
    </router-link>

    <router-link to="/Config/Team" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ]">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-group"></i>
          <span class="menu-text">ข้อมูลทีม</span>
        </a>
      </li>
    </router-link>

    <router-link to="/Config/User" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ]">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-user-outline-symbol"></i>
          <span class="menu-text">ข้อมูลผู้ใช้</span>
        </a>
      </li>
    </router-link>

    <router-link to="/Config/Building" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ]">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-menu-3"></i>
          <span class="menu-text">ข้อมูลอาคาร</span>
        </a>
      </li>
    </router-link>

    <router-link to="/Config/Contract" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ]">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-contract"></i>
          <span class="menu-text">ข้อมูลสัญญา</span>
        </a>
      </li>
    </router-link>
  </ul>
</template>

<script>
export default {
  name: "KTMenu",
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    }
  }
};
</script>
